import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastService, ToastData } from '../../services/toast.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit, OnDestroy {
    toast: ToastData | null = null;
    isVisible = false;
    private subscription: Subscription = new Subscription();
    private timeoutId: any;

    constructor(private toastService: ToastService) { }

    ngOnInit(): void {
        this.subscription = this.toastService.toastState$.subscribe((data) => {
            this.show(data);
        });
    }

    show(data: ToastData): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.toast = data;
        this.isVisible = true;

        this.timeoutId = setTimeout(() => {
            this.isVisible = false;
            setTimeout(() => {
                this.toast = null;
            }, 500); // Wait for fade out animation
        }, data.duration || 3000);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
}
